import React from 'react';
export default function Rule(): React.JSX.Element {
	return <hr role="presentation" />;
}
